import { defineMessages } from 'react-intl'

const scope = `procurify.expense.featureSet.TravelApprovalListView`

export default defineMessages({
  allTabLabel: {
    id: `${scope}.allTabLabel`,
    defaultMessage: 'All',
  },
  pendingTabLabel: {
    id: `${scope}.pendingTabLabel`,
    defaultMessage: 'Pending',
  },
  approvedTabLabel: {
    id: `${scope}.approvedTabLabel`,
    defaultMessage: 'Approved',
  },
  deniedTabLabel: {
    id: `${scope}.deniedTabLabel`,
    defaultMessage: 'Denied',
  },
  viewingAsLabel: {
    id: `${scope}.viewingAsLabel`,
    defaultMessage: 'Viewing as',
  },
  approveSuccessToastTitle: {
    id: `${scope}.approveSuccessToastTitle`,
    defaultMessage: 'Travel requests approved',
  },
  approveSuccessToastMessage: {
    id: `${scope}.approveSuccessToastMessage`,
    defaultMessage: 'Travel request(s) have been approved successfully',
  },
  approveErrorToastTitle: {
    id: `${scope}.approveErrorToastTitle`,
    defaultMessage: 'Unable to approve travel requests',
  },
  approveErrorToastMessage: {
    id: `${scope}.approveErrorToastMessage`,
    defaultMessage: 'An error occurred approving travel requests',
  },
  denySuccessToastTitle: {
    id: `${scope}.denySuccessToastTitle`,
    defaultMessage: 'Travel requests denied',
  },
  denySuccessToastMessage: {
    id: `${scope}.denySuccessToastMessage`,
    defaultMessage: 'Travel request(s) have been denied successfully',
  },
  denyErrorToastTitle: {
    id: `${scope}.denyErrorToastTitle`,
    defaultMessage: 'Unable to deny travel requests',
  },
  denyErrorToastMessage: {
    id: `${scope}.denyErrorToastMessage`,
    defaultMessage: 'An error occurred denying travel requests',
  },
})
